import { render } from "./MicrosoftLogo.vue?vue&type=template&id=ca26b424"
const script = {}

import exportComponent from "/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__